import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import authenticationServices from '../../../services/authentication-services';
import Button from '../../../shared/components/atoms/button/button';
import Input from '../../../shared/components/atoms/input/input';
import PassForceConfirmation from '../pass-force-confirmation/pass-force-confirmation';
import './force-pass-change.scss';

const ForcePassChange = ({ password, tokenData, setModalContent, setActiveToast }) => {

    const { register, handleSubmit, setValue, getValues, formState: { errors } } = useForm();
    const [loading, setLoading] = useState(false)

    const onSubmit = (data) => {

        setLoading(true)
        const payload = {
            accessToken: tokenData.accessToken,
            previousPassword: password,
            proposedPassword: data.newPassword
        }
        let config = {
            headers: {
                Authorization: tokenData.idToken,
            },
        }
        authenticationServices.forceUpdatePassword(payload, config).then(
            response => {
                setLoading(false)
                if (response.status === 200) {
                    localStorage.setItem("TOKEN_INFO", JSON.stringify(tokenData));
                    setModalContent(<PassForceConfirmation />)
                } else {
                    setActiveToast({
                        messageToast: response.userMessage,
                        checkToast: false
                    })
                }
            }
        )
    }

    const [levelSecurity, setLevelSecurity] = useState(0)
    const [copylevelSecurity, setCopyLevelSecurity] = useState("Débil")
    const [type, setType] = useState("password")

    const changePassword = e => {
        //(?=.*[0-9])(?![.\n])(?![*\s])(?=.*[A-Z])(?=.*[a-z]).
        if (e.target.value.length > 5) {
            var numberSecurity = 0
            var val = e.target.value
            if (/[a-z]/.test(val)) {
                numberSecurity++
            }
            if (/[A-Z]/.test(val)) {
                numberSecurity++
            }
            if (/[0-9]/.test(val)) {
                numberSecurity++
            }
            if (/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(val)) {
                numberSecurity++
            }
            switch (numberSecurity) {
                case 1:
                    setLevelSecurity(1)
                    setCopyLevelSecurity("Débil")
                    break
                case 2:
                    setLevelSecurity(2)
                    setCopyLevelSecurity("Medio")
                    break
                case 3:
                    setLevelSecurity(2)
                    setCopyLevelSecurity("Medio")
                    break
                case 4:
                    setLevelSecurity(3)
                    setCopyLevelSecurity("Fuerte")
                    break

                default:
                    setLevelSecurity(1)
                    setCopyLevelSecurity("Débil")
                    break
            }
        } else {
            setLevelSecurity(1)
            setCopyLevelSecurity("Débil")
        }
    }

    return (
        <>
            <form onSubmit={handleSubmit((e) => onSubmit(e))} className="f-m-ForcePassChange">
                <p className="f-m-ForcePassChange__title">¡Crea una nueva contraseña!</p>
                <p className="f-m-ForcePassChange__sub-title">Piensa en una contraseña que siempre recuerdes para que ingreses fácil y rápido cuando vuelvas a visitarnos</p>
                <div className="f-m-ForcePassChange__password">
                    <div className="f-m-ForcePassChange__password-input">
                        <div
                            className="f-m-ForcePassChange__password-input-icon"
                            onClick={() => {
                                if (type === "password") {
                                    setType("text")
                                } else {
                                    setType("password")
                                }
                            }}
                        ></div>
                        <Input
                            label="Ingresa tu contraseña"
                            name="newPassword"
                            maxLength="50"
                            type={type}
                            placeholder="Ingresa tu contraseña"
                            register={register}
                            setValue={setValue}
                            error={errors ? errors.newPassword : ""}
                            onChange={changePassword}
                            validationRules={
                                {
                                    required:
                                    {
                                        value: true,
                                        message: 'Campo requerido'
                                    },
                                    minLength: {
                                        value: 6,
                                        message: '*La contraseña debe ser de mínimo 6 caracteres'
                                    }
                                }
                            }
                        />

                    </div>
                    <div className="f-m-ForcePassChange-form-item-seguritypw">
                        <span className="active" />
                        <span className={levelSecurity > 1 ? "active" : ""} />
                        <span className={levelSecurity > 2 ? "active" : ""} />
                        <p>{copylevelSecurity}</p>
                    </div>
                </div>
                <Button
                    className="f-a-button__primary-purple f-a-button__extra-big "
                    type="submit"
                    id="f-a-button__ForcePassChange"
                    copy={"Actualizar"}
                    loader={loading}
                />
            </form>
        </>
    )
}

export default ForcePassChange
